module.exports = __webpack_public_path__ + "img/login_aziende_jobmule_home.0886e63d.jpg";